import { render, staticRenderFns } from "./OrderStatusChip.vue?vue&type=template&id=ae3f0a30&scoped=true"
import script from "./OrderStatusChip.vue?vue&type=script&lang=js"
export * from "./OrderStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3f0a30",
  null
  
)

export default component.exports